'use strict';
import React, {Component} from 'react';
import $ from 'jquery';
import "chosen-js/chosen.css";
import "chosen-js/chosen.jquery.js";

class CcMultiChosen extends Component {
  constructor(){
    super();
    this.state = {
        tasks : null,
        selectedowners : '',
    }

        this.handleChange = this.handleChange.bind(this);

}
  componentDidMount() {
    this.$el = $(this.el);
    //this.$el.chosen();
   
    this.handleChange = this.handleChange.bind(this);
    this.$el.on('change', this.handleChange);
  }

  componentWillUnmount() {
    this.$el.off('change', this.handleChange);
    //this.$el.chosen('destroy');
  }
  
  handleChange(e) {
    this.props.onChange(e.target.value);
  }
 
  render() {
    return (
        <select data-placeholder="Choose Owners..." class="form-control"  multiple name="ccselectlist" id="ccselectlist" ref={el => this.el = el} defaultValue=''>
          {this.props.children}
        </select>
    );
  }
  }
  export default CcMultiChosen;

  


// WEBPACK FOOTER //
// ./src/CcMultiChosen.js